<template>
<v-container style="max-width: 1100px">
  <v-card-title class="headline form-fill-header">{{ formName }}</v-card-title>
  <div style="margin-top:20px" v-for="field in fields" :key="field.id">
    <component :field="field" :isEditing="true" :is="getInputComponent(field.type)" :context="Context.createFormContextWithFields(fields)" :value="getValue(field.order)" @setValue="setValue($event, field.order)">
    </component>
  </div>

  <v-card-actions>
    <v-spacer></v-spacer>
    <v-btn :disabled="loading" large round class="primary" @click="submit(states.COMPLETED)">{{ $t("base.save") }}</v-btn>
  </v-card-actions>
</v-container>
</template>

<script>
import http from "@/plugins/http"
import TextInput from "./inputs/Text"
import NumberInput from "./inputs/Number"
import DateInput from "./inputs/Date"
import TimeInput from "./inputs/Time"
import RadioInput from "./inputs/Radio"
import TableInput from "./inputs/Table"
import MultipleInput from "./inputs/Multiple"
import SignatureInput from "./inputs/Signature"
import PhotoInput from "./inputs/Photo"
import CodeInput from "./inputs/Code"
import ArchiveInput from "./inputs/Archive"
import RelatedInput from "./inputs/Related"
import DependInput from "./inputs/SelectDepend"
import CheckboxInput from "./inputs/Checkbox"
import StorageInput from "./inputs/Storage.vue"
import states from '@/enums/states'
import fieldType from '@/enums/fieldType'
import Context from '@/plugins/Context'

export default {
  name: "Edit",
  components: {
    TextInput,
    NumberInput,
    DateInput,
    TimeInput,
    RadioInput,
    TableInput,
    MultipleInput,
    SignatureInput,
    PhotoInput,
    CodeInput,
    ArchiveInput,
    RelatedInput,
    CheckboxInput,
    DependInput,
    StorageInput
  },
  data() {
    return {
      Context,
      formName: "",
      fields: [],
      states: states,
      payload: {
        results: []
      },
      loading: false
    }
  },
  created() {
    this.loading = true

    let schema = http.get('schema/' + this.$route.params.schemaId)
    let form = http.get('form/' + this.$route.params.schemaId + '/' + this.$route.params.formId)


    Promise.all([schema, form]).then(data => {
      this.loading = false
      this.fields = data[0].data.fields.filter(field => !fieldType.hidden.includes(field.type))
      this.formName = data[0].data.name
      this.payload = data[1].data
    }).catch(() => {
      this.$route.push({
        name: "not-found"
      })
    })
  },
  methods: {
    getInputComponent(type) {
      return type + "-input"
    },
    getFieldInfo(id) {
      return this.fields.find(field => field.id == id)
    },
    getFieldValue(id) {
      let field = this.getFieldInfo(id)
      if (!field) return undefined

      let cell = this.payload.results.find(cell => cell.order == field.order)
      if (cell) {
        return cell.value
      }
    },
    getValue(order) {
      let cell = this.payload.results.find(cell => cell.order == order)
      if (cell) {
        return cell.value
      }
      return ''
      
    },
    setValue(value, order) {
      let cell = this.payload.results.find(cell => cell.order == order)
      if (cell) {
        cell.value = value
      } else {
        this.payload.results.push({
          order,
          value
        })
      }
    },
    notUpdateField(field) {
      return !fieldType.notUpdate.includes(field.type)
    },
    submit(state) {
      this.loading = true
      this.payload.state = state
      this.payload.results = this.payload.results.filter(this.notUpdateField)
      http.put('form/' + this.$route.params.schemaId + '/' + this.$route.params.formId, this.payload)
        .then(() => {
          this.loading = false
          this.$store.commit("setSnack", {
            "message": this.$t("form.fill.success-message", {
              "form-name": this.formName
            }),
            "color": "success"
          })
          this.$router.back()
        })
    }
  },
}
</script>

<style>
.form-fill-header {
  margin: 11px;
}

.v-list__tile {
  height: auto;
  margin: 16px 0;
}
</style>
